import "./Progress.css";

/**
 * How far along something is.
 *
 * Two jobs: catalogue completeness, and the bulk-edit background job. Both
 * want the same thing — a determinate bar with the number beside it, because a
 * bar alone tells you roughly and people want exactly.
 */

export interface ProgressProps {
  /** 0–1. Values outside are clamped rather than overflowing the track. */
  value: number;
  label: string;
  /** Hides the numeric readout, for tight rows. */
  compact?: boolean;
  tone?: "accent" | "ok";
}

export function Progress({ value, label, compact = false, tone = "accent" }: ProgressProps) {
  const pct = Math.round(Math.min(1, Math.max(0, value)) * 100);

  return (
    <div className={`ui-progress ui-progress--${tone} ${compact ? "is-compact" : ""}`}>
      <div
        className="ui-progress__track"
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <span className="ui-progress__fill" style={{ width: `${pct}%` }} />
      </div>
      {!compact && <span className="ui-progress__value">{pct}%</span>}
    </div>
  );
}
